import { CancelOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import moment from "moment";
import ExistingFileDetails from "./ExistingFileDetails";

const BerkasSidangUploadFileField = ({
  title,
  deadline,
  inputName,
  acceptedFileTypes,
  onFileUpload,
  onResetUploadedFile,
  uploadedFile,
  existingFile,
  deskripsi,
  maxFileSize,
  required,
}) => {
  const deadlineMoment = deadline
    ? moment(`${deadline.tanggal} ${deadline.jam}`, "YYYY-MM-DD HH:mm:ss")
    : moment();

  return (
    <div className="flex flex-col gap-3 p-2 rounded border-2 border-dashed border-slate-300">
      <div>
        <div className="text-lg font-bold">
          {title} {required && <span className="text-red-500">*</span>}
        </div>
        {deskripsi && <small>{deskripsi}</small>}
        <div className={`${deskripsi && "pt-2"}`}>
          <span className="font-bold">Deadline pengumpulan: </span>
          <span className="font-bold text-red-500">
            {deadline
              ? `${deadlineMoment.format("DD/MM/YYYY HH:mm")} WIB`
              : "-"}
          </span>
        </div>
      </div>
      <div className="flex flex-col">
        {deadlineMoment.isAfter(moment()) ? (
          <>
            <div className="flex flex-row gap-2 items-center border rounded">
              <label className="shrink-0 p-2 text-white bg-sky-600 rounded-l hover:bg-sky-700 hover:cursor-pointer">
                <input
                  name={inputName}
                  type="file"
                  accept={acceptedFileTypes}
                  hidden
                  onChange={onFileUpload}
                />
                Unggah Berkas
              </label>
              {uploadedFile && (
                <>
                  <div className="truncate">{uploadedFile.name}</div>
                  <IconButton
                    LinkComponent={"button"}
                    onClick={onResetUploadedFile}
                    sx={{ padding: 0, marginRight: 1 }}
                  >
                    <CancelOutlined color="error" />
                  </IconButton>
                </>
              )}
            </div>
            <small>
              <b>Format:</b> {acceptedFileTypes}
              {maxFileSize ? (
                <>
                  <b> || Maks ukuran file:</b> {maxFileSize}
                </>
              ) : (
                <></>
              )}
            </small>
          </>
        ) : (
          <span>
            Submisi {title}{" "}
            <span className="text-red-500">
              telah melewati deadline pengumpulan
            </span>{" "}
            sehingga anda tidak dapat lagi melakukan submisi berkas!
          </span>
        )}
      </div>
      <ExistingFileDetails berkasSidang={existingFile} />
    </div>
  );
};

export default BerkasSidangUploadFileField;
